import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { UIRouterModule } from '@uirouter/angular';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { MessagePanelModule } from '@ng-falcon/messages/message-panel/message-panel.module';
import { AlertComponent } from './alert/alert.component';
import { TagBtnComponent } from './tag-btn/tag-btn.component';
import { IdentityVerificationBannerComponent } from './identity-verification-banner/identity-verification-banner.component';
import { UtCustomDropdownComponent } from './custom-dropdown/ut-custom-dropdown.component';
import { StarRatingComponent } from './star-rating/star-rating.component';
import { LoadingDotsComponent } from './loading-dots/loading-dots.component';
import { CommentBtnComponent } from '../../shared/comment-btn/comment-btn.component';
import { TabsComponent, TabComponent } from './tabs';
import { SocialSharingComponent, SocialSharingPopoverComponent } from '../social-sharing';
import { AvatarBadgesComponent } from '../avatar-badges';
import { ImpersonationOverlayComponent } from './impersonation-overlay';
import { FeedPaginatorComponent } from './feed-paginator';
import { LoadMoreComponent } from './load-more/load-more.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    UIRouterModule,
    UIRouterUpgradeModule,
    OverlayModule,
    PortalModule,
    MessagePanelModule,
  ],
  declarations: [
    AlertComponent,
    TagBtnComponent,
    IdentityVerificationBannerComponent,
    UtCustomDropdownComponent,
    StarRatingComponent,
    LoadingDotsComponent,
    CommentBtnComponent,
    SocialSharingComponent,
    SocialSharingPopoverComponent,
    AvatarBadgesComponent,
    ImpersonationOverlayComponent,
    FeedPaginatorComponent,
    LoadMoreComponent,
    TabsComponent,
    TabComponent,
  ],
  exports: [
    AlertComponent,
    TagBtnComponent,
    IdentityVerificationBannerComponent,
    UtCustomDropdownComponent,
    StarRatingComponent,
    LoadingDotsComponent,
    CommentBtnComponent,
    SocialSharingComponent,
    SocialSharingPopoverComponent,
    AvatarBadgesComponent,
    ImpersonationOverlayComponent,
    FeedPaginatorComponent,
    LoadMoreComponent,
    TabsComponent,
    TabComponent,
  ],
})
export class CommonComponentsModule { }
